(function documentsShortcutsDefinition() {
    'use strict';
    angular.module('Entities')
        .service('documentsShortcutsService', [
            'restUrlBuilder', '$injector', 'config', function documentsShortcutsService(restUrlBuilder, $injector, config) {

                this.findShort = function get(name, id, createdBy, createdDateFrom, createdDateTo, ou, page, itemsPerPage, orderBy, asc) {
                    var params = { Name: name, Id: id, CreatedBy: createdBy, CreatedDateFrom: createdDateFrom, CreatedDateTo: createdDateTo, ItemPerPage: itemsPerPage, Page: page, OrganizationalUnitId: ou, OrderBy: orderBy, OrderAscendent: asc};

                    return restUrlBuilder.all('DocumentsShortcuts')
                        .get({ params: params });
                };

                this.replaceFile = function replaceFile(replaceFile, file) {
                    if (replaceFile == null) {
                        throw "replaceFile no puede ser null";
                    }

                    var $upload = $injector.get('Upload');

                    if ($upload == null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: config.apiUrl('/DocumentsShortcuts/replaceFile'),
                        method: 'PUT',
                        fields: { replaceFile: JSON.stringify(replaceFile) },
                        file: file,
                        fileFormDataName: 'imageFile'
                    });
                };


            }
        ]);
})();